import { Injectable } from "@angular/core";
import { GemsHttpService } from "../../../shared/services/gems-http.service";
import { constants } from '../../../constants/all.constants';
import { SafeHarborPlans } from "client/app/domains/SafeHarborPlans";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class SafeHarborService {
  constructor(
    private gemsHttp: GemsHttpService
  ) { }

  loadSafeHarborPlans() {
    let url = constants.apiRoutes.safeHarbor.safeHarborPlans;
    console.log('1: ' + url);
    return this.gemsHttp.get(url).pipe(
      map(mapSafeHarborPlans),
      catchError(err => {
        console.error('error', err);
        return of([]);
      })
    );
  }

  submitSafeHarborNotices(obj) {
    // let url = 'http://test7.benefitsservices.nreca.org/AaRspd.Services/SafeHarborService/SafeHarborCoops.svc/submitsafeharborplans';

    //http://test7.benefitsservices.nreca.org/AaRspdWebAPI.Services/api/RetirementDocuments/submitsafeharborplans
    let url = constants.apiRoutes.safeHarbor.submitSafeHarborPlans;
    // console.log('1: ' + url);
    //url = 'http://test7.benefitsservices.nreca.org/AaRspdWebAPI.Services/api/RetirementDocuments/submitsafeharborplans';
    console.log('2: ' + url);
    return this.gemsHttp.post(url, obj).pipe(
      catchError(err => {
        console.error('error', err);
        return of([]);
      })
    );
  }
}

function mapSafeHarborPlans(response: any) {
  let data = response.result;
  let documents: SafeHarborPlans[] = [];
  for (let i = 0; i < data.length; i++) {
    let document: SafeHarborPlans = {
      DocumentId: data[i].documentId,
      SubgroupId: data[i].subgroupId,
      CoopName: data[i].coopName
    }
    documents.push(document);
  }
  return documents;
}
